// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VJJ9","controls":"styles_controls__2yUZS","charLimit":"styles_charLimit__DfE8h","input":"styles_input__6PJjF","send":"styles_send__194I0"};